import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, AfterViewInit } from '@angular/core';
import { CommonService } from 'src/app/modules/service/common/common.service';

declare let BMap: any;
let map;
let point;

@Component({
  selector: 'my-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.less'],
})
export class MapComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() show: boolean = false;
  @Input() style: object = {
    width: '1000px',
    height: '470px',
  };
  @Input() search: string = '';
  @Input() result: any = '';
  @Input() location = { longitude: '', latitude: '' };
  @Output() locationChange = new EventEmitter();

  constructor(private common: CommonService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    return console.log('暂时废弃 map.components.html');
    this.common.loading(true);
    let result = [];
    if (this.result == '') {
      result = [116.404, 39.915];
    } else {
      result = this.result ? this.result.split(',') : [116.404, 39.915];
    }

    const new_point = new BMap.Point(result[0], result[1]);
    map = new BMap.Map('map'); // 创建地图实例
    point = new BMap.Point(new_point); // 创建点坐标
    map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    setTimeout(() => {
      map.clearOverlays();
      const marker = new BMap.Marker(new_point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(new_point);
    }, 500);
    map.addEventListener('tilesloaded', () => {
      this.common.loading(false);
    });
    const geoc = new BMap.Geocoder();
    map.addEventListener('click', (res) => {
      this.getLocation(res);
    });
  }

  /**
   * 外部传参事件
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['result'] != undefined && this.result != undefined) {
      const result = this.result.split(',');
      this.location = { longitude: result[0], latitude: result[1] };
    }
  }

  /**
   * 检索数据
   */
  searchData(): any {
    if (this.search == '') {
      this.common.msg.warning('请输入检索关键字');
      return false;
    }
    this.common.loading(true);
    map.clearOverlays(); // 清除地图上所有覆盖物
    this.result = '';
    const local = new BMap.LocalSearch(map, {
      renderOptions: { map },
      onSearchComplete: (res) => {
        this.common.loading(false);
      },
    });
    local.search(this.search);
  }

  getLocation(e: any): void {
    this.location = { longitude: e.point.lng, latitude: e.point.lat };
    this.result = e.point.lng + ',' + e.point.lat;
    this.locationChange.emit({ target: 'check', details: this.location });
    const new_point = new BMap.Point(e.point.lng, e.point.lat);
    map.clearOverlays();
    const marker = new BMap.Marker(new_point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中
    map.panTo(new_point);
    map.setCenter(new_point);
  }
}
